import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=ce912552&scoped=true"
import script from "./ScrollToTop.vue?vue&type=script&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&lang=js"
import style0 from "./ScrollToTop.vue?vue&type=style&index=0&id=ce912552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce912552",
  null
  
)

export default component.exports